import React, { Component } from "react";
import * as PIXI from "pixi.js";
import UIManager from "../../core/components/ui/UiBuilder";
import { withPixiApp } from "@inlet/react-pixi";
import { GJIStore } from "../../gamestore/IStore";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withsymbolbganimcontainerconfiguration from "./configuration/withstreakeffectcontainerconfiguration";
import { isMobile } from "react-device-detect";
import StreakEffectComponent from "../streakEffect/streakeffect";
import { configGame, constant } from "../../data/config";
import { TIMER } from "../../core/utills";


interface IStore {
    [x: string]: any;
}
interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IStateToProps {
}

interface IDispatchToProps {
}

class StreakEffectContainer extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected displayUI: any;
    protected streakEffectContainer: any;
    protected streakEffectComponentContainer: any;
    protected streakEffect_container: any;
    protected scope: any;
    protected ui_mode: string;
    protected streakEffectComponentList: Array<any>

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.streakEffectContainer = React.createRef();
        this.streakEffectComponentContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }

        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        //reel,row
        this.streakEffectComponentList = [
            [0, 1]
        ];

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    componentDidMount() {

    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.streakEffectList !== this.props.streakEffectList
            || nextProps.showStreak !== this.props.showStreak
        ) {

            if (nextProps.streakEffectList !== this.props.streakEffectList) {
                this.setSymbolAnimationList(nextProps.streakEffectList);
                return true;
            }
            if (nextProps.showStreak && nextProps.showStreak !== this.props.showStreak) {
                this.showStreakAnimations();
            }
            return false;

        }
        return true;
    }

    showStreakAnimations() {
        let animContainer: any = UIManager.getRef("streakEffectContainer").children
        animContainer.forEach((element: any, index: any) => {
            let animObj = element.children[0]
            animObj.play();
            animObj.visible = true;
            animObj.onComplete = ()=>{
                animObj.gotoAndStop(0);
                animObj.visible = false;
            }
        });
       
    }

    setSymbolAnimationList(streakEffectList: any) {
        this.streakEffectComponentList = streakEffectList;
    }

    render() {
        let reelContainerX = configGame.REEL_CONTAINER_X;
        let reelContainerY = configGame.REEL_CONTAINER_Y;
        const streakEffect = [];
        for (var i = 0; i < this.streakEffectComponentList.length; i++) {

            let PROPS_TO_SEND_StreakEffectComponent = {
                key: `UIManagerBg-${Math.random()}`,
                count: i,
                visible: true,
                langObj: this.props.langObj,
                canvasApp: this.app,
                streakEffectCoordinate: this.streakEffectComponentList[i],
            }

            streakEffect.push(
                <StreakEffectComponent {...PROPS_TO_SEND_StreakEffectComponent} />
            );
        }
        return (<UIManager id={"streakEffectContainer"} name={"streakEffectContainer"} type={"Container"}
            ref={i => this.streakEffectContainer = i}
            x={reelContainerX} y={reelContainerY}>
            {
                this.displayUI && this.displayUI.map((i: any) =>
                    <UIManager key={`UIManagerBg-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                        id={i.id} {...i} app={this.app} />)
            }
            {streakEffect}

        </UIManager>)
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'streakEffectState' | 'applicationState'>): IStateToProps =>
    ({
        streakEffectList: state.streakEffectState.streakEffectList,
        showStreak: state.streakEffectState.showStreak
    }),
    (dispatch: Dispatch): IDispatchToProps => ({

    }))(withsymbolbganimcontainerconfiguration(StreakEffectContainer)));